import { SiteName } from '@/scopes/common/domain/types'

const BOOKING_PAYMENT_PAGE_CONTEXT_ITEM_IDS: Partial<Record<SiteName, string>> = {
  sunwebnl: '81FB6635-F3B8-4C37-8CAF-5C36FACA7A23',
  sunwebbenl: '8D1ED941-591C-4D91-AB98-17103687949B',
  sunwebbefr: '93CCDB0C-F92D-4CE1-8875-E39934A879B2',
  sunwebde: 'DC7BC4D1-9257-495E-A120-88408C9B2696',
  sunwebfr: 'CCD7237F-4C10-4CEE-89CD-0C1D294681B3',
  sunwebdk: '4BEBADD9-2D48-4076-8086-E0053B068CB7',
  sunwebse: 'C18BD050-A1F6-4EA1-A61D-750A92E47AA0',
  sunwebuk: '9593ED84-1FE0-47EE-B39E-9547590832B2',
  elizanl: '7A1E0CF5-36BE-4113-B112-30582A0CC723',
  elizabe: '134B6B4D-5542-4CAA-9ED9-06207A360135',
}

export function getContextItemIdBookingPaymentPage(siteName: SiteName): string {
  return BOOKING_PAYMENT_PAGE_CONTEXT_ITEM_IDS[siteName] || ''
}
